/**
 * Os nós do `SupervisorGraph` — espelho de `core/supervisor/grafo.py`
 * (`ORDEM_DOS_NOS`) e dos estados de `node-status` de `core/sse.py`
 * (`ESTADOS_NO`). ★ [review #2364, item D]
 *
 * Só a ORDEM e os ESTADOS moram aqui; a copy humana de cada nó fica em
 * `constants/TextChat.js::ROTULO_DO_NO_DO_TURNO` (só copy entra lá).
 *
 * ## Por que a ordem importa
 *
 * VERIFICADO no checkout irmão (`grafo.py::executar_turno`, único produtor
 * do evento): o backend emite `node-status` só com `estado: concluido`, ao
 * FIM de cada nó (`stream_mode=['updates', ...]` entrega o delta de cada nó
 * quando ele termina). Um `concluido` diz, portanto, onde o turno ESTÁ AGORA:
 * no nó SEGUINTE. É esta lista que responde "qual é o seguinte" —
 * `utils/rotulo-do-turno.js::rotuloDoNoDoTurno` — e uma posição trocada faz a
 * linha de raciocínio anunciar a etapa errada sem erro nenhum. A junção
 * `NosDoSupervisor.juncao.unit.js` lê o `.py` e trava o drift.
 *
 * Os nós do `DomainAgentGraph` (`fabrica.py`: `normalize_task`, `execute`,
 * ...) NÃO entram: só o Supervisor emite o evento.
 */

/** Vocabulário FECHADO de `node-status.estado` (`core/sse.py::ESTADOS_NO`). */
export const ESTADO_DO_NO = Object.freeze({
  INICIADO: 'iniciado',
  CONCLUIDO: 'concluido',
  FALHOU: 'falhou',
})

/** `grafo.py::ORDEM_DOS_NOS`, byte a byte, na ordem em que o grafo os roda. */
export const ORDEM_DOS_NOS_DO_SUPERVISOR = Object.freeze([
  'initialize_run',
  'authenticate_and_authorize',
  'understand_request',
  'load_global_context',
  'route_domains',
  'enter_advisory_hub',
  'build_delegation_plan',
  'execute_domain_agents',
  'aggregate_results',
  'fallback_apos_tentativa',
  'cross_domain_reasoning',
  'validate_answer',
  'determine_actions',
  'approval_gate',
  'execute_approved_actions',
  'compose_response',
  'complete_run',
  'emit_learning_event',
])
